import React from 'react';
import { reduxForm, Field } from 'redux-form';

import InputField from 'components/InputField';
import FormError from 'components/FormError';

import styles from './styles.module.scss';

const ActivateSubModalForm = ({
  sub,
  isAgentOrAdminOrManager,
  handleSubmit,
  error,
}) => {
  return (
    <form onSubmit={handleSubmit}>
      <div className={styles.row}>
        <div className={styles.item}>
          <Field component={InputField} name="pin" />
        </div>
        {isAgentOrAdminOrManager && (
          <div className={styles.item}>
            <Field component={InputField} name="mdn" />
          </div>
        )}
      </div>
      {error && <FormError error={error} />}
      <br />
      <button className="btn btn-primary">Activate Subscription</button>
    </form>
  );
};

const validate = (values, { isSimo }) => {
  let errors = {};

  return errors;
};

export default reduxForm({
  form: 'activateSub',
  validate,
  enableReinitialize: true,
})(ActivateSubModalForm);
